import languages, { alternateLanguages } from "config/languages";
import type { LanguageCode } from "config/languages";

export const checkIfValidLanguage = (language: LanguageCode) =>
  !!alternateLanguages[language] || !!languages.get(language);
